import { useCallback } from 'react';
import { audioManager, SoundType } from '../audio';

export const useSound = () => {
  const play = useCallback((type: SoundType) => {
    audioManager.play(type);
  }, []);

  const stop = useCallback((type: SoundType) => {
    audioManager.stop(type);
  }, []);

  const stopAll = useCallback(() => {
    audioManager.stopAll();
  }, []);

  const mute = useCallback(() => {
    audioManager.mute();
  }, []);

  const unmute = useCallback(() => {
    audioManager.unmute();
  }, []);

  const toggleMute = useCallback(() => {
    audioManager.toggleMute();
  }, []);

  const setVolume = useCallback((volume: number) => {
    audioManager.setVolume(volume);
  }, []);

  return {
    play,
    stop,
    stopAll,
    mute,
    unmute,
    toggleMute,
    setVolume,
    isMuted: audioManager.isMuted(),
    volume: audioManager.getVolume(),
  };
};
